export default {
  name: 'Name',
  category: 'Category',
  type: 'Type',
  startDate: 'Start date',
  endDate: 'End date',
};
